import React from 'react';
import styled from 'styled-components';
import { Card, Heading, NameText, Date as Date_, Text } from './Review.styles';
import starImages from './starImages';

export const getInitials = (children: string) => {
  const parts = children.split(' ');

  const init1 = parts[0].charAt(0) || '';
  const init2 = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';

  return init1 + init2 || '?';
};

export type Props = {
  id: string;
  stars: number;
  title: string;
  text: string;
  language: string;
  isVerified: boolean;
  consumer: {
    displayName: string;
  };
  createdAt: string;
};

export const Review = (p: Props) => {
  const StarsImg = styled(starImages[p.stars.toPrecision(2)])`
    height: 18px;
    width: auto;
  `;

  const dateStr = `${new Date(p.createdAt).toLocaleDateString('en-au', {
    day: 'numeric',
    month: 'short',
  })}`;

  return (
    <Card>
      <StarsImg />
      <Date_ text={dateStr !== 'Invalid Date' ? dateStr : ''} variant="small" />
      <Heading>{p.title}</Heading>
      <Text text={p.text} />
      <NameText>{p.consumer.displayName.toLowerCase()}</NameText>
    </Card>
  );
};
